/** Post-login / post-signup redirect when no `next` query param is provided. */
export const resolvePostLoginPath = (safeNext: string | null): string => {
  return safeNext ?? "/";
};

/** Same-origin `next` that is not a Paperclip client route needs a document load. */
export const wantsDocumentReload = (reloadParam: string | null): boolean =>
  reloadParam === "1" || reloadParam === "true";

export const redirectAfterLogin = ({
  safeNext,
  reload,
  navigate,
  assign = (url) => {
    window.location.assign(url);
  },
}: {
  safeNext: string | null;
  reload: boolean;
  navigate: (path: string, options: { replace: boolean }) => void;
  assign?: (url: string) => void;
}): void => {
  const path = resolvePostLoginPath(safeNext);
  if (reload && safeNext) {
    assign(path);
    return;
  }
  navigate(path, { replace: true });
};
